import { SupplierUpdatePage } from '@/features/supplier/pages/SupplierUpdatePage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/supplier/$id/update')({
  component: SupplierUpdatePage,
})
